import React, { useEffect, useState } from "react";
import { Grid, Card, Button } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { fetchParentescos, buscarParentesco, agregarParentesco, modificarParentesco } from "../../../actions/abm/abmParentescos";
import { TIPO_PARENTESCO_PERMISOS } from "../../../utils/permisos";
import TableGeneric from "../../compartidos/abms/TableGeneric";
import AccionesGenericoAbm from "../../compartidos/abms/AccionesGenericoAbm";
import ModalAbm from '../../compartidos/abms/ModalAbm';
import BuscadorAbm from "../../compartidos/abms/BuscadorAbm";
import { FormParentesco } from "./FormParentesco";

const useStyles = makeStyles({
  botonera: {
    padding: 25
  }
});
export const HomeTiposParentescos = () => {

  const classes = useStyles();
  const { items } = useSelector((state) => state.tipoParentescos);
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [openAlta, setParentescoAlta] = useState(false);
  const [parentesco, setParentesco] = useState(false);

  useEffect(() => {
    dispatch(fetchParentescos());
  }, [dispatch]);

  const handleSearch = (textoBuscado) => {
    dispatch(buscarParentesco(textoBuscado));
  };

  const handleSelectParentesco = (item) => {
    setParentesco(item);
    setOpen(true);
  }

  const handleSave = (item) => {
    if (item.idParentesco) {
      dispatch(modificarParentesco(item));
    } else {
      dispatch(agregarParentesco(item.descripcionParentesco));
    }
  };

  return (
    <div>
      <Grid container justify="center">
        <ModalAbm title="Agregar Parentesco" open={openAlta} setOpen={setParentescoAlta}>
          <FormParentesco parentesco={null} handleSave={handleSave} cerrarModal={() => setParentescoAlta(false)} permisoAlta={TIPO_PARENTESCO_PERMISOS.ALTA}  />
        </ModalAbm>
        <ModalAbm title="Modificar Parentesco" open={open} setOpen={setOpen}>
          <FormParentesco parentesco={parentesco} handleSave={handleSave} cerrarModal={() => setOpen(false)} permisoEdit={TIPO_PARENTESCO_PERMISOS.MODIFICACION} />
        </ModalAbm>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={() => setParentescoAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar Parentesco</Button>
        </Grid>
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar Parentesco" handleSearch={handleSearch} />
        </Grid>
        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }}>
          <Card>
            <TableGeneric
              data={items}
              columns={[
                {
                  label:"",
                  customBody:(item) => (
                    <AccionesGenericoAbm
                      item={item}
                      handleItemSelect={handleSelectParentesco}
                    />
                  )
                },
                {
                  label: "Parentesco",
                  id: "descripcionParentesco",
                  sort: true
                }
              ]}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  );

};
export default HomeTiposParentescos;
